import { Flex } from "@chakra-ui/react";
import dayjs from "dayjs";
import type { APIListingEvent } from "models/types/api-listing";
import { CardRecordMeta } from "components/cards/card-record-meta";
import { useFormatMoney } from "hooks/use-format-money";
import { InterestLevelBadge } from "modules/vendor-portal/components/interest-level-badge";
import { FooterText } from "modules/vendor-portal/screens/overview/components/feedback/footer/footer-text";
import { dateFormats } from "utils/date";

type PrivateInspectionEventFooterProps = {
  event: APIListingEvent;
  isTruncated?: boolean;
};
export function PrivateInspectionEventInsetFooter({
  event,
  isTruncated,
}: PrivateInspectionEventFooterProps) {
  const formatMoney = useFormatMoney();
  const { feedback } = event;

  return (
    <CardRecordMeta wrap={isTruncated ? "nowrap" : "wrap"}>
      {feedback ? (
        <>
          <FooterText text={feedback.agent.name} />

          {feedback.interest_level ? (
            <InterestLevelBadge interestLevel={feedback.interest_level} />
          ) : null}

          {!feedback.price_indication ? null : (
            <FooterText
              text={`Price indication ${formatMoney(
                feedback.price_indication,
              )}`}
            />
          )}
        </>
      ) : null}

      <Flex direction={"row"} align={"center"} gap={2}>
        <FooterText
          text={dayjs(event.starts_at).format(dateFormats.dayMonthYear)}
        />

        {/* TODO: Add is_new badge */}
      </Flex>
    </CardRecordMeta>
  );
}
